import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_price_book_ext_RowClass} from '../../../dbschema/bl_fi_mst_price_book_ext.model';
import {bl_fi_mst_price_book_hdr_RowClass} from '../../../dbschema/bl_fi_mst_price_book_hdr.model';
import {bl_fi_mst_price_book_line_RowClass} from '../../../dbschema/bl_fi_mst_price_book_line.model';

export class PriceBookContainerModel extends BaseContainerModel {
  bl_fi_mst_price_book_hdr: bl_fi_mst_price_book_hdr_RowClass = new bl_fi_mst_price_book_hdr_RowClass();
  bl_fi_mst_price_book_exts: bl_fi_mst_price_book_ext_RowClass[] = [];
  bl_fi_mst_price_book_lines: bl_fi_mst_price_book_line_RowClass[] = [];
}
